import { useEffect, useRef, useState } from 'react'
import Loader from 'react-loaders'
import { AnimatedLetters } from '../AnimatedLetters'
import './index.scss'
import emailjs from '@emailjs/browser'
import { MapContainer, TileLayer, Marker, Popup} from 'react-leaflet'

export const Contact = () => {

    const [letterClass, setLetterClass] = useState('text-animate');
    const refForm = useRef();

    useEffect(() => {
        setTimeout(() => {
          return setLetterClass('text-animate-hover')
        }, 3000)
      }, [])

      const sendEmail = (e) => {
        e.preventDefault();

        emailjs
        .sendForm(
            'service_v4a2u3d',
            'contact_form',
            refForm.current,
            '0zkW5ksPupo9yYk3e'
        )
        .then(
            (response) => {
                alert('Message succesfully sent!')
                console.log( response.status, response.text)
                window.location.reload(false)
            },
            (error) => {
                alert('Failed to send the message, please try again')
                console.log(error)
            }
        )
      }


  return (
    <>
        <div className='container contact-page'>
            <div className='text-zone'>
                <h1>
                    <AnimatedLetters 
                    letterClass={ letterClass }
                        strArray={"Contact me".split("")} 
                        idx={15}    
                    />
                </h1>
                <p>
                    I am interested in ambitious or large projects. However,
                    if you have other request or question, 
                    don't hesitate to contact me using below form either.
                </p>
                <div className='contact-form'>
                    <form ref={ refForm } onSubmit={ sendEmail }>
                        <ul>
                            <li className='half'>
                                <input type="text" name='name' placeholder='Name' required/>
                            </li>
                            <li className='half'>
                                <input type="email" name='email' placeholder='Email' required/>
                            </li>
                            <li>
                                <input placeholder="Subject" type="text" name='subject'required />
                            </li>
                            <li>
                                <textarea placeholder='Message' name='message' required></textarea>
                            </li>
                            <li>
                                <input type="submit" className='flat-button' value="SEND" />
                            </li>
                        </ul>
                    </form>
                </div>
            </div>
            <div className='info-map'>
                William Jaimes,
                <br />
                Colombia,
                <br />
                Atlantico 
                <br />
                Barranquilla
                <span>william.jaimesfontalvo@gmail.com</span>
            </div>
            <div className='map-wrap'>
                <MapContainer center={[11.017238459504807, -74.82483408420623]} zoom={13}>
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>
                    <Marker position={[11.017238459504807, -74.82483408420623]}>
                        <Popup>William lives here, come over for a shake :)</Popup>
                    </Marker>
                </MapContainer>
            </div>
        </div>
        <Loader type='pacman'/>
    </>
  )
}
